module.exports = __webpack_public_path__ + "img/119_marathon.c6bcb55a.jpg";